module.exports = __webpack_public_path__ + "static/media/girl.22a1e808.png";